export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
};

export type Background = {
  readonly __typename?: 'Background';
  readonly attachment: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly size: Scalars['String']['output'];
  readonly src: Scalars['String']['output'];
};

export type Card = {
  readonly __typename?: 'Card';
  readonly createdAt: Scalars['Date']['output'];
  readonly creator: Profile;
  readonly design: Design;
  readonly headline: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly plan: PlanType;
  readonly postCount: Scalars['Int']['output'];
  readonly recipientName: Scalars['String']['output'];
  readonly senderName?: Maybe<Scalars['String']['output']>;
  readonly status: Status;
  readonly updatedAt: Scalars['Date']['output'];
};

/** A list of Cards paginated according to GraphQL Cursor Connection specification */
export type CardConnection = {
  readonly __typename?: 'CardConnection';
  /** List of edges */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CardEdge>>>;
  /** Information to aid pagination */
  readonly pageInfo: PageInfo;
  /** Count of nodes */
  readonly totalCount: Scalars['Int']['output'];
};

export type CardEdge = {
  readonly __typename?: 'CardEdge';
  /** Cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** Item at end of edge */
  readonly node?: Maybe<Card>;
};

export type CardFilter = {
  readonly status?: InputMaybe<Status>;
};

export type CardInput = {
  readonly designId: Scalars['String']['input'];
  readonly headline: Scalars['String']['input'];
  readonly recipientName: Scalars['String']['input'];
  readonly senderName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOAuthUserInput = {
  readonly idToken: Scalars['String']['input'];
};

export type CreateUserInput = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly password: Scalars['String']['input'];
};

export type Delivery = {
  readonly __typename?: 'Delivery';
  readonly cardId: Scalars['String']['output'];
  readonly createdAt: Scalars['Date']['output'];
  readonly method: DeliveryMethod;
  readonly recipientEmail?: Maybe<Scalars['String']['output']>;
  readonly status: DeliveryStatus;
};

export type DeliveryInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly method: DeliveryMethod;
};

export const DeliveryMethod = {
  Email: 'Email',
  Manual: 'Manual'
} as const;

export type DeliveryMethod = typeof DeliveryMethod[keyof typeof DeliveryMethod];
export const DeliveryStatus = {
  Failure: 'Failure',
  Pending: 'Pending',
  Success: 'Success'
} as const;

export type DeliveryStatus = typeof DeliveryStatus[keyof typeof DeliveryStatus];
export type Design = {
  readonly __typename?: 'Design';
  readonly background: Background;
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly priority?: Maybe<Scalars['Int']['output']>;
};

export type DesignConnection = {
  readonly __typename?: 'DesignConnection';
  /** List of edges */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DesignEdge>>>;
  /** Information to aid pagination */
  readonly pageInfo: PageInfo;
  /** Count of nodes */
  readonly totalCount: Scalars['Int']['output'];
};

export type DesignEdge = {
  readonly __typename?: 'DesignEdge';
  /** Cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** Item at end of edge */
  readonly node?: Maybe<Design>;
};

export type EmailVerificationInput = {
  readonly code: Scalars['String']['input'];
};

/** Reusable response type when nothing meaningful could be returned */
export type EmptyResponse = {
  readonly __typename?: 'EmptyResponse';
  readonly _empty?: Maybe<Scalars['Boolean']['output']>;
};

export type EmptyResponseOrImageUpload = EmptyResponse | ImageUpload;

export type ForgotPasswordInput = {
  readonly email: Scalars['String']['input'];
};

/** Reusable type for a signed URL image upload */
export type ImageUpload = {
  readonly __typename?: 'ImageUpload';
  readonly publicUrl?: Maybe<Scalars['String']['output']>;
  readonly signedUrl: Scalars['String']['output'];
};

export type ImageUploadInput = {
  readonly fileExtension: Scalars['String']['input'];
};

export type Invoice = {
  readonly __typename?: 'Invoice';
  readonly cardId: Scalars['ID']['output'];
  readonly cardRecipient: Scalars['String']['output'];
  readonly createdAt: Scalars['Date']['output'];
  readonly currencyCode: Scalars['String']['output'];
  readonly customer: TransactionCustomer;
  readonly id: Scalars['ID']['output'];
  readonly invoiceNumber: Scalars['Int']['output'];
  readonly item: TransactionItem;
  readonly payment: TransactionPayment;
  readonly status: Scalars['String']['output'];
  readonly totals: TransactionTotals;
  readonly transactionId: Scalars['ID']['output'];
  readonly transactionTimestamp: Scalars['Date']['output'];
  readonly updatedAt: Scalars['Date']['output'];
  readonly userId: Scalars['ID']['output'];
};

/** A list of Invoices paginated according to GraphQL Cursor Connection specification */
export type InvoiceConnection = {
  readonly __typename?: 'InvoiceConnection';
  /** List of edges */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InvoiceEdge>>>;
  /** Information to aid pagination */
  readonly pageInfo: PageInfo;
  /** Count of nodes */
  readonly totalCount: Scalars['Int']['output'];
};

export type InvoiceEdge = {
  readonly __typename?: 'InvoiceEdge';
  /** Cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** Item at end of edge */
  readonly node?: Maybe<Invoice>;
};

export type Media = {
  readonly __typename?: 'Media';
  readonly src: Scalars['String']['output'];
  readonly type: MediaType;
};

export type MediaInput = {
  readonly extension?: InputMaybe<Scalars['String']['input']>;
  readonly src: Scalars['String']['input'];
  readonly type: MediaType;
};

export const MediaType = {
  Giphy: 'GIPHY',
  Image: 'IMAGE'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Create a card */
  readonly createCard: Card;
  /** Create an OAuth user */
  readonly createOAuthUser: User;
  /** Create a post */
  readonly createPost: EmptyResponseOrImageUpload;
  /** Create a user */
  readonly createUser: User;
  /** Delete a card */
  readonly deleteCard: EmptyResponse;
  /** Delete a post */
  readonly deletePost: EmptyResponse;
  /** Deliver a card */
  readonly deliverCard: EmptyResponse;
  /** Download an invoice */
  readonly downloadInvoice: PDFDownload;
  /** Forgot password */
  readonly forgotPassword: EmptyResponse;
  /** Reset password */
  readonly resetPassword: EmptyResponse;
  /** Send email verification */
  readonly sendEmailVerification: EmptyResponse;
  /** Update a card */
  readonly updateCard: EmptyResponse;
  /** Update a post */
  readonly updatePost: EmptyResponseOrImageUpload;
  /** Update a user */
  readonly updateUser: EmptyResponse;
  /** Upgrade a card */
  readonly upgradeCard: Invoice;
  /** Validate an OAuth user (after login) */
  readonly validateOAuthUser: EmptyResponse;
  /** Verify email */
  readonly verifyEmail: EmptyResponse;
};


export type MutationcreateCardArgs = {
  input: CardInput;
};


export type MutationcreateOAuthUserArgs = {
  input: CreateOAuthUserInput;
};


export type MutationcreatePostArgs = {
  cardId: Scalars['ID']['input'];
  input: PostInput;
};


export type MutationcreateUserArgs = {
  input: CreateUserInput;
};


export type MutationdeleteCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeletePostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeliverCardArgs = {
  id: Scalars['ID']['input'];
  input: DeliveryInput;
};


export type MutationdownloadInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationforgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationresetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationupdateCardArgs = {
  id: Scalars['ID']['input'];
  input: CardInput;
};


export type MutationupdatePostArgs = {
  id: Scalars['ID']['input'];
  input: PostInput;
};


export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationupgradeCardArgs = {
  id: Scalars['ID']['input'];
  input: TransactionInput;
};


export type MutationvalidateOAuthUserArgs = {
  input: ValidateOAuthUserInput;
};


export type MutationverifyEmailArgs = {
  input: EmailVerificationInput;
};

/** Reusable type for a PDF download */
export type PDFDownload = {
  readonly __typename?: 'PDFDownload';
  readonly url: Scalars['String']['output'];
};

/** Information about a connection page. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** Cursor used to fetch next pages. Last edge in a connection. */
  readonly endCursor: Scalars['String']['output'];
  /** Whether there are more pages to fetch */
  readonly hasNextPage: Scalars['Boolean']['output'];
};

export type PaginationInput = {
  readonly after?: InputMaybe<Scalars['String']['input']>;
  readonly first?: InputMaybe<Scalars['Int']['input']>;
};

export const PlanType = {
  Basic: 'Basic',
  Pro: 'Pro'
} as const;

export type PlanType = typeof PlanType[keyof typeof PlanType];
export type Post = {
  readonly __typename?: 'Post';
  readonly author?: Maybe<Profile>;
  readonly createdAt: Scalars['Date']['output'];
  readonly id: Scalars['ID']['output'];
  readonly media?: Maybe<Media>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['Date']['output'];
};

/** A list of Posts paginated according to GraphQL Cursor Connection specification */
export type PostConnection = {
  readonly __typename?: 'PostConnection';
  /** List of edges */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PostEdge>>>;
  /** Information to aid pagination */
  readonly pageInfo: PageInfo;
  /** Count of nodes */
  readonly totalCount: Scalars['Int']['output'];
};

export type PostEdge = {
  readonly __typename?: 'PostEdge';
  /** Cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** Item at end of edge */
  readonly node?: Maybe<Post>;
};

export type PostInput = {
  readonly media?: InputMaybe<MediaInput>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

/** Reusable type for a user's profile */
export type Profile = {
  readonly __typename?: 'Profile';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type Query = {
  readonly __typename?: 'Query';
  /** Get a card */
  readonly card: Card;
  /** Get cards under an authenticated user */
  readonly cards: CardConnection;
  /** Get a delivery by card id */
  readonly deliveryByCardId?: Maybe<Delivery>;
  /** Get a design */
  readonly design: Design;
  /** Get designs */
  readonly designs: DesignConnection;
  /** Get an invoice */
  readonly invoice: Invoice;
  /** Get invoices under an authenticated user */
  readonly invoices: InvoiceConnection;
  /** Get a post */
  readonly post: Post;
  /** Get posts under a card */
  readonly postsByCardId: PostConnection;
  /** Get list of signatures under an authenticated user */
  readonly signatures: SignatureConnection;
  /** Get current authenticated user */
  readonly user: User;
};


export type QuerycardArgs = {
  consumer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerycardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerydeliveryByCardIdArgs = {
  cardId: Scalars['ID']['input'];
};


export type QuerydesignArgs = {
  id: Scalars['ID']['input'];
};


export type QuerydesignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryinvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerypostArgs = {
  id: Scalars['ID']['input'];
};


export type QuerypostsByCardIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ResetPasswordInput = {
  readonly password: Scalars['String']['input'];
  readonly token: Scalars['String']['input'];
};

export type Signature = {
  readonly __typename?: 'Signature';
  readonly card: Card;
  readonly timestamp: Scalars['Date']['output'];
};

/** A list of Signatures paginated according to GraphQL Cursor Connection specification */
export type SignatureConnection = {
  readonly __typename?: 'SignatureConnection';
  /** List of edges */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SignatureEdge>>>;
  /** Information to aid pagination */
  readonly pageInfo: PageInfo;
  /** Count of nodes */
  readonly totalCount: Scalars['Int']['output'];
};

export type SignatureEdge = {
  readonly __typename?: 'SignatureEdge';
  /** Cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** Item at end of edge */
  readonly node?: Maybe<Signature>;
};

export type SortInput = {
  readonly sortBy: Scalars['String']['input'];
  readonly sortOrder: SortOrder;
};

export const SortOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export const Status = {
  Active: 'Active',
  Published: 'Published',
  Sent: 'Sent'
} as const;

export type Status = typeof Status[keyof typeof Status];
export type TransactionAddress = {
  readonly __typename?: 'TransactionAddress';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly countryCode: Scalars['String']['output'];
  readonly firstLine?: Maybe<Scalars['String']['output']>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly secondLine?: Maybe<Scalars['String']['output']>;
};

export type TransactionCard = {
  readonly __typename?: 'TransactionCard';
  readonly last4?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type TransactionCustomer = {
  readonly __typename?: 'TransactionCustomer';
  readonly address: TransactionAddress;
  readonly email: Scalars['String']['output'];
};

export type TransactionInput = {
  readonly transactionId: Scalars['String']['input'];
};

export type TransactionItem = {
  readonly __typename?: 'TransactionItem';
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly price: Scalars['String']['output'];
};

export type TransactionPayment = {
  readonly __typename?: 'TransactionPayment';
  readonly card?: Maybe<TransactionCard>;
  readonly method: Scalars['String']['output'];
};

export type TransactionTotals = {
  readonly __typename?: 'TransactionTotals';
  readonly discount: Scalars['String']['output'];
  readonly grandTotal: Scalars['String']['output'];
  readonly subtotal: Scalars['String']['output'];
  readonly tax: Scalars['String']['output'];
  readonly total: Scalars['String']['output'];
};

export type UpdateUserInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  readonly __typename?: 'User';
  readonly createdAt: Scalars['Date']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isVerified: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['Date']['output'];
};

export type ValidateOAuthUserInput = {
  readonly email: Scalars['String']['input'];
};
